import React, { useState } from 'react';
import { Button, Confirm } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import { IntegrityAlert } from './IntegrityAlert';

const ButtonArea = ({
  id,
  isDetails,
  isAdd,
  handleDelete,
  handleSubmit,
  isSubmitDisabled,
  backURL,
  editURL = '',
  editName = '',
  showEditButton = true,
  showDeleteButton = true,
  references = [],
  typeString = 'das Objekt',
  isChangedToInactive = false,
  ...props
}) => {
  const history = useHistory();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showReferencesModal, setShowReferencesModal] = useState(false);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [refModalReason, setRefModalReason] = useState('delete');

  return (
    <>
      <Confirm
        open={showSaveModal}
        onCancel={() => {
          setShowSaveModal(false);
        }}
        onConfirm={(e) => {
          handleSubmit(e);
          setShowSaveModal(false);
        }}
        header="Speichern bestätigen"
        content={`Wollen Sie ${typeString} speichern?`}
        cancelButton="Abbrechen"
        confirmButton="Speichern"
      />
      <Confirm
        open={showDeleteModal}
        onCancel={() => {
          setShowDeleteModal(false);
        }}
        onConfirm={() => {
          handleDelete();
          setShowDeleteModal(false);
        }}
        header="Löschen bestätigen"
        content={`Wollen Sie ${typeString} wirklich löschen?`}
        cancelButton="Abbrechen"
        confirmButton="Löschen"
      />
      <IntegrityAlert
        open={showReferencesModal}
        onCancel={() => {
          setShowReferencesModal(false);
        }}
        onConfirm={(e) => {
          if (refModalReason === 'archive') {
            handleSubmit(e);
          } else if (refModalReason === 'delete') {
            handleDelete({ force: true });
          }
          setShowReferencesModal(false);
        }}
        header={`Sollte womöglich nicht ${
          refModalReason === 'delete' ? 'gelöscht' : 'archiviert'
        } werden`}
        references={references}
        cancelButton="Abbrechen"
        confirmButton={`Trotzdem ${
          refModalReason === 'delete' ? 'löschen' : 'archivieren'
        }`}
      />

      {!isDetails ? (
        <div className="buttonArea">
          <Button
            primary
            onClick={() => {
              if (backURL) {
                history.push(backURL);
              } else {
                history.goBack();
              }
            }}
          >
            Abbrechen
          </Button>
          <Button
            primary
            onClick={() => {
              if (isChangedToInactive) {
                setRefModalReason('archive');
                setShowReferencesModal(true);
              } else {
                setShowSaveModal(true);
              }
            }}
            disabled={isSubmitDisabled}
          >
            Speichern
          </Button>
          {!isAdd && showDeleteButton && (
            <Button
              onClick={() => {
                if (references && references.length > 0) {
                  setRefModalReason('delete');
                  setShowReferencesModal(true);
                } else {
                  setShowDeleteModal(true);
                }
              }}
            >
              Löschen
            </Button>
          )}
        </div>
      ) : (
        <div className="buttonArea">
          <Button
            primary
            onClick={() => {
              if (backURL) {
                history.push(backURL);
              } else {
                history.goBack();
              }
            }}
          >
            Zurück
          </Button>
          {showEditButton && (
            <Button
              type="New"
              onClick={() => {
                history.push(`${editURL}edit?id=${id}`);
              }}
            >
              {editName} Bearbeiten
            </Button>
          )}
          {showDeleteButton && (
            <Button
              onClick={() => {
                if (references && references.length > 0) {
                  setRefModalReason('delete');
                  setShowReferencesModal(true);
                } else {
                  setShowDeleteModal(true);
                }
              }}
            >
              {editName} Löschen
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default ButtonArea;
